import { Box, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SmartScreenIcon from '@mui/icons-material/SmartScreen';
import AddTaskIcon from '@mui/icons-material/AddTask';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';

const valuesDetailsList = [
    {
        color: "#fc845b",
        icon: <AccessibilityIcon sx={{color: 'white'}}/>,
        title: "about.values.value1.title",
        description: "about.values.value1.description"
    },
    {
        color: "#fcb95b",
        icon: <SmartScreenIcon sx={{color: 'white'}}/>,
        title: "about.values.value2.title",
        description: "about.values.value2.description"
    },
    {
        color: "#5bb6fc",
        icon: <AddTaskIcon sx={{color: 'white'}}/>,
        title: "about.values.value3.title",
        description: "about.values.value3.description"
    },
    {
        color: "#a65bfc",
        icon: <HealthAndSafetyIcon sx={{color: 'white'}}/>,
        title: "about.values.value4.title",
        description: "about.values.value4.description"
    }
]

const OurValues = () => {
    const {t} = useTranslation();

    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='start'
                container
                className='bodySpacing bodyPadding'
                width='100%'
                spacing={{xs: 1, md: 2}}
            >   
                <Grid size={{xs: 12, md: 6}}>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: {xs: 45, md: 60, lg: 75},
                            color: 'white',
                            lineHeight: 1.15,
                            textAlign: {xs: 'center', md: 'left'}
                        }}
                        data-aos="fade-up"
                        data-aos-duration="1000"
                    >
                        {t('about.values.title')}
                    </Typography>
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <Stack
                        direction='column'
                        justifyContent='center'
                        alignItems='center'
                        spacing={{xs: 1, md: 2}}
                    >
                        {
                            valuesDetailsList.map((item, index) => {
                                return <OurValueDetails 
                                    key={index}
                                    data={item}
                                    index={index}
                                />
                            })
                        }
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
}

export default OurValues;

const OurValueDetails = ({data, index}) => {
    const {t} = useTranslation();

    return (
        <>
            <Box
                sx={{
                    borderRadius: 4,
                    backgroundColor: data.color,
                    p: {xs: 2, md: 5},
                    width: '95%'
                }}
                data-aos="fade-up"
                data-aos-delay={index * 150}
                data-aos-duration="1000"
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='start'
                    spacing={{xs: 1, md: 2}}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        {data.icon}
                    </Box>

                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: {xs: 16, md: 20, lg: 32},
                            color: 'white',
                            lineHeight: 1
                        }}
                    >
                        {t(data.title)}
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: {xs: 12, md: 14, lg: 16},
                            textAlign: 'left',
                            color: 'white'
                        }}
                    >
                        {t(data.description)}
                    </Typography>
                </Stack>
            </Box>
        </>
    );
}